/** ProComponents SearchSelect 仍通过顶层属性管理搜索值和清空事件。 */
export function proRemoteSearch(onSearch: (keyword: string) => void) {
  return {
    showSearch: true,
    filterOption: false as const,
    onSearch
  }
}
